import React from "react"
import ErrorIcon from "@mui/icons-material/Error"
import { ErrorMessages } from "../../Const"
import styles from "./styles.module.scss"

interface Props {
  isEmpty?: boolean
  isUnselected?: boolean
  carNameIsUnselected?: boolean
  isNotEmailFormat?: boolean
  beginsWithHyphen?: boolean
  noCarModel?: boolean
  ineligibleCarType?: boolean
  childIsUnder18?: boolean
  isWrongCertificateColor?: boolean
  isNotSameEmail?: boolean
  isNotCharacterLimit?: boolean
  isNotNumberAlphabet?: boolean
  isSameEmailId?: boolean
  containsProhibitedHalfLetters?: boolean
  containsProhibitedFullLetters?: boolean
}
/**
 * バリデーションチェックのエラーメッセージ部品
 * 必要なバリデーションチェックの引数を選択し、条件文をその引数に設定する
 * @param {boolean} isEmpty - 未入力チェック
 * @param {boolean} isUnselected - 未選択チェック
 * @param {boolean} carNameIsUnselected - 車名一覧未選択チェック
 * @param {boolean} isNotEmailFormat - メールフォーマットチェック
 * @param {boolean} beginsWithHyphen - ハイフン始まりチェック（未使用のため、削除予定）
 * @param {boolean} noCarModel - 型式存在チェック
 * @param {boolean} ineligibleCarType - 用途車種チェック（未使用のため、削除予定）
 * @param {boolean} childIsUnder18 - １８歳未満チェック（未使用のため、削除予定）
 * @param {boolean} isWrongCertificateColor - 車検証の色チェック
 * @param {boolean} isNotSameEmail - メールアドレス（確認要）の一致チェック
 * @param {boolean} isNotCharacterLimit - 文字数チェック（パスワード）
 * @param {boolean} isNotNumberAlphabet - 半角英数字チェック
 * @param {boolean} isSameEmailId - メールアドレス前方がパスワードと一致しないチェック
 * @param {boolean} containsProhibitedHalfLetters - 半角文字チェック（未使用のため、削除予定）
 * @param {boolean} containsProhibitedFullLetters - 全角文字チェック（未使用のため、削除予定）
 */
const ErrorMessage: React.FC<Props> = ({
  isEmpty = false,
  isUnselected = false,
  carNameIsUnselected = false,
  isNotEmailFormat = false,
  beginsWithHyphen = false,
  noCarModel = false,
  ineligibleCarType = false,
  childIsUnder18 = false,
  isWrongCertificateColor = false,
  isNotSameEmail = false,
  isNotCharacterLimit = false,
  isNotNumberAlphabet = false,
  isSameEmailId = false,
  containsProhibitedHalfLetters = false,
  containsProhibitedFullLetters = false
}) => {
  const isError = () => {
    return (
      isEmpty ||
      isUnselected ||
      carNameIsUnselected ||
      isNotEmailFormat ||
      beginsWithHyphen ||
      noCarModel ||
      ineligibleCarType ||
      childIsUnder18 ||
      isWrongCertificateColor ||
      isNotSameEmail ||
      isNotCharacterLimit ||
      isNotNumberAlphabet ||
      isSameEmailId ||
      containsProhibitedHalfLetters ||
      containsProhibitedFullLetters
    )
  }
  return (
    <div className={styles.errorMessage} style={{ display: isError() ? "initial" : "none" }}>
      <div className={styles.errorMessage__box}>
        <div className={styles.errorMessage__icon}>
          <ErrorIcon style={{ color: "#FF5A02" }} />
        </div>
        <ul>
          {isEmpty && <li className={styles.errorMessage__message}>{ErrorMessages.REQUIRED}</li>}
          {isUnselected && <li className={styles.errorMessage__message}>{ErrorMessages.NOT_SELECTED}</li>}
          {isNotEmailFormat && <li className={styles.errorMessage__message}>{ErrorMessages.IS_NOT_EMAIL_FORMAT}</li>}
          {isNotCharacterLimit && (
            <li className={styles.errorMessage__message}>{ErrorMessages.IS_NOT_CHARACTER_LIMIT}</li>
          )}
          {isNotNumberAlphabet && (
            <li className={styles.errorMessage__message}>{ErrorMessages.IS_NOT_NUMBER_ALPHABET}</li>
          )}
          {isSameEmailId && <li className={styles.errorMessage__message}>{ErrorMessages.IS_SAME_EMAIL_ID}</li>}
          {noCarModel && <li className={styles.errorMessage__message}>{ErrorMessages.NO_CAR_MODEL}</li>}
          {ineligibleCarType && <li className={styles.errorMessage__message}>{ErrorMessages.INELIGIBLE_CAR_TYPE}</li>}
          {isWrongCertificateColor && (
            <li className={styles.errorMessage__message}>{ErrorMessages.IS_WRONG_CERTIFiCATE_COLOR}</li>
          )}
          {isNotSameEmail && <li className={styles.errorMessage__message}>{ErrorMessages.IS_NOT_SAME_EMAIL}</li>}
        </ul>
      </div>
    </div>
  )
}

export default ErrorMessage
